export const ResponseCode = {
    INVALID_TRACKING_ID: "INVALID_TRACKING_ID",
    RETURN_TO_SELLER: "RETURN_TO_SELLER",
    WRONG_STATION: "WRONG_STATION",
    NO_PATH_PLAN: "NO_PATH_PLAN",
    UNEXPECTED_STATUS: "UNEXPECTED_STATUS",
    DAMAGED: "DAMAGED"
}